






























































































































































































































































import { collections } from "@/configs/firebase";
import { Vue, Component, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import logger from "@/configs/logger";
import { snakeCase } from "lodash";
import { storage } from "@/configs/firebase";
import { objectify } from "@/helpers";
import { User } from "@/types";
import {
  addPhoneNumberToBlacklist,
  deletePhoneNumberToBlacklist,
  sendFileLinkForBlacklist
} from "@/lib/api";
import moment from "moment";

@Component
export default class Blacklist extends Vue {
  @State("user") user!: User;
  deleteDialog: boolean = false;
  selectedPhoneNumber: string = "";
  uploadPercent: number = 0;
  uploading: boolean = false;
  blacklistFile: any = {};
  activeTab = "single";
  valid = true;
  dialog = false;
  snack = false;
  snackText = "";
  snackColor = "";
  loading = false;
  products: any[] = [];
  blockedInbound: boolean = true;
  searchBlacklistString: string = "";
  phoneNumber: string = "";
  email: string = "";
  requiredRules = [(v: string) => !!v || "This field is required"];
  blacklist: any[] = [];
  headers = [
    {
      text: "Phone Number",
      align: "start",
      value: "phone_number"
    },
    {
      text: "Email",
      value: "email"
    },
    {
      text: "Blocked Inbound",
      value: "blocked_inbound",
      align: "center"
    },
    {
      text: "Source",
      value: "source"
    },
    {
      text: "Posted By",
      value: "posted_by"
    },
    {
      text: "Filename",
      value: "file_name"
    },
    {
      text: "Action",
      value: "action",
      align: "center"
    }
  ];
  limit = 10;
  limitOptions = [10, 20, 40, 80];
  pageNumber = 0;
  addBlacklistError = false;
  addBlacklistErrorText = "";

  mounted() {
    this.loadBlacklist();
  }

  @Watch("searchBlacklistString")
  onEmptySearch(val: string) {
    if (!val) {
      this.loadBlacklist();
    }
  }

  onChangeLimit(val: number) {
    this.limit = val;
    this.loadBlacklist();
  }

  async handlePreviousPage() {
    this.loading = true;
    this.pageNumber = this.pageNumber - 1;
    const firstNumber = this.blacklist[0].phone_number;
    logger("info", firstNumber);
    try {
      const snap = await collections.blacklistNumber
        .orderBy("phone_number")
        .endBefore(firstNumber)
        .limitToLast(this.limit)
        .get();

      this.blacklist = snap.docs.map((doc: any) => ({
        id: doc.id,
        ...doc.data()
      }));
      this.loading = false;
    } catch (err) {
      this.loading = false;
      Vue.toasted.error("Get DIDs failed" + err);
      logger("error", "Logout failed", err);
    }
  }

  async handleNextPage() {
    this.loading = true;
    this.pageNumber = this.pageNumber + 1;
    const [lastNumber]: any = this.blacklist.slice(-1);
    logger("info", lastNumber);
    try {
      const snap = await collections.blacklistNumber
        .orderBy("phone_number")
        .startAfter(lastNumber.phone_number)
        .limit(this.limit)
        .get();

      this.blacklist = snap.docs.map((doc: any) => ({
        id: doc.id,
        ...doc.data()
      }));
      this.loading = false;
    } catch (err) {
      this.loading = false;
      Vue.toasted.error("Get DIDs failed" + err);
      logger("error", "Logout failed", err);
    }
  }

  async loadBlacklist() {
    this.loading = true;
    try {
      const snap = await collections.blacklistNumber
        .orderBy("phone_number")
        .limit(this.limit)
        .get();

      this.blacklist = snap.docs.map((doc: any) => ({
        id: doc.id,
        ...doc.data()
      }));
      this.loading = false;
    } catch (err) {
      this.loading = false;
      Vue.toasted.error("Get DIDs failed" + err);
      logger("error", "Logout failed", err);
    }
  }

  showSnack(message: string, type: "success" | "info" | "error") {
    this.snack = true;
    this.snackColor = type || "info";
    this.snackText = message;
  }

  async searchBlacklist() {
    try {
      if (this.searchBlacklistString) {
        this.loading = true;
        const snap = await collections.blacklistNumber
          .where(
            `${
              this.searchBlacklistString.includes("@")
                ? "email"
                : "phone_number"
            }`,
            "==",
            this.searchBlacklistString
          )
          .get();

        this.blacklist = snap.docs.map((doc: any) => ({
          id: doc.id,
          ...doc.data()
        }));
        this.loading = false;
      }
    } catch (error) {
      this.loading = false;
      this.$toasted.error("Error searching for blacklist").goAway(2000);
    }
  }

  async submitBlacklist() {
    try {
      this.loading = true;
      await addPhoneNumberToBlacklist(
        this.phoneNumber,
        this.blockedInbound,
        this.user.email
      );
      this.resetBlacklistForm();
      this.loadBlacklist();
      this.showSnack("Phone number successfully added!", "success");
    } catch (err) {
      if (err.response.data.detail.length > 0) {
        this.addBlacklistError = true;
        this.addBlacklistErrorText = err.response.data.detail.join(", ");
      } else if (err.response.data.error) {
        this.$toasted.error(err.response.data.error).goAway(2000);
      } else {
        this.$toasted.error("unable to add phone number").goAway(2000);
      }
      return false;
    } finally {
      this.loading = false;
    }
  }

  // @ts-ignore-start
  async uploadBlacklist() {
    if (objectify(this.blacklistFile)) {
      this.uploading = true;
      const storagePath = `${this.blacklistFile.name}-${this.user.email.slice(
        0,
        3
      )}-${moment().toISOString()}`;

      try {
        logger("log", "starting upload", this.blacklistFile);

        const uploadTask = storage()
          .ref(storagePath)
          .put(this.blacklistFile);

        uploadTask.on(
          "state_changed",
          (snapshot: any) => {
            this.uploadPercent = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
          },
          (err: any) => {
            logger("error", err);
          },
          () => {
            sendFileLinkForBlacklist(
              storagePath,
              this.blockedInbound,
              this.user.email
            );
            this.loadBlacklist();
            this.uploading = false;
            this.uploadPercent = 0;
            this.showSnack("File successfully uploaded!", "success");
            this.resetBlacklistForm();
          }
        );
      } catch (error) {
        logger("error", error);
      }
    }
  }

  // @ts-ignore-end
  resetBlacklistForm() {
    this.phoneNumber = "";
    this.email = "";
    this.blacklistFile = {};
    this.dialog = false;
    this.addBlacklistError = false;
    this.addBlacklistErrorText = "";
  }

  showDeleteDialog(item: any) {
    this.deleteDialog = true;
    this.selectedPhoneNumber = item.phone_number;
  }

  hideDeleteDialog() {
    this.deleteDialog = false;
    this.selectedPhoneNumber = "";
  }

  async save(item: any) {
    try {
      await collections.blacklistNumber
        .doc(item.id)
        .update({ blocked_inbound: item.blocked_inbound });
      this.showSnack("Blacklist updated", "success");
    } catch (error) {
      this.$toasted.error("unable to update blacklist").goAway(2000);
    }
  }

  async deletePhoneNumber() {
    try {
      this.loading = true;
      const response = await deletePhoneNumberToBlacklist(
        this.selectedPhoneNumber
      );
      this.showSnack("Phone number successfully deleted.", "success");
      this.loadBlacklist();
    } catch (err) {
      this.$toasted.error("unable to delete phone number").goAway(2000);
      return false;
    } finally {
      this.loading = false;
      this.hideDeleteDialog();
    }
  }

  cancel() {
    //this.showSnack("Canceled", "error");
  }

  open() {
    //this.showSnack("Dialog opened", "info");
  }

  close() {
    //console.log("Dialog closed");
  }
}
